import React from 'react';
import { useAuth } from '../context/AuthContext';
import { SharedShipmentDetail } from './shared/SharedShipmentDetail';

const ROLE_BASE: Record<string, string> = {
  SUPER_ADMIN: '/super-admin/shipments',
  COMPANY_ADMIN: '/company-admin/shipments',
  DISPATCH_AGENT: '/dispatch/shipments',
  RECOVERY_OFFICER: '/recovery/shipments',
  COMPANY_AGENT: '/agent/shipments',
  INDEPENDENT_USER: '/user/shipments',
  TRANSPORTER: '/transporter/shipments',
  WAREHOUSE_MANAGER: '/warehouse/shipments',
  INVENTORY_AUDITOR: '/warehouse/shipments',
};

export const ShipmentDetailPage: React.FC = () => {
  const { user } = useAuth();
  const basePath = (user?.role && ROLE_BASE[user.role]) || '/shipments';
  return <SharedShipmentDetail basePath={basePath} />;
};
